import { createRestClient } from '@superbet-group/web.lib.rest';
import { logger } from '../logger';

// TODO: Remove after hackathon
export function createOmniWalletService(host: string) {
    const restClient = createRestClient(
        host,
        3_000,
        false,
    );

    async function getUserWallet(retailUserId: number): Promise<OmniWalletStatus> {
        try {
            const response = await restClient.get<OmniWalletResponse>(`/wallet/retail/balance/${retailUserId}`);

            return {
                walletBalance: response.walletBalance.available,
                cashbackBalance: response.cashbackBalance.remaining,
            };
        } catch (error) {
            logger.error(error as Error);
            return {
                walletBalance: 0,
                cashbackBalance: 0,
            };
        }
    }

    return {
        getUserWallet,
    };
}

export const omniWalletService = createOmniWalletService('https://omniwallet-sb-ro.incubator-ingress.eu-central-1.dev.incubator.sb-cloud.io/sbclub-api/api');

type OmniWalletResponse = {
    walletBalance: {
        available: number;
    };
    cashbackBalance: {
        remaining: number;
    };
};

export type OmniWalletStatus = {
    walletBalance: number;
    cashbackBalance: number;
};
